<template>
    <div class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto">
        <div class="rounded-lg shadow-xs overflow-hidden">
            <div class="flex p-4" :class="description ? 'items-start' : 'items-center'">
                <div class="flex-shrink-0">
                    <nio-icon class="text-lg" :class="iconClassName" :name="iconName" />
                </div>
                <div class="ml-3 w-0 flex-1">
                    <p class="text-sm text-gray-800" :class="{ 'font-medium': description }">
                        <router-link
                            class="link underline hover:text-gray-600"
                            :to="link"
                            @click.native="hide"
                            v-text="message"
                            v-if="link"
                        />
                        <span v-text="message" v-else />
                    </p>
                    <p class="mt-1 text-sm text-gray-500 clamp-3" v-html="description" v-if="description" />
                </div>
                <div class="ml-4 flex-shrink-0 flex">
                    <button class="text-gray-400 hover:text-gray-500 focus:text-gray-500 transition ease-in-out duration-150" @click="hide" v-if="closable">
                        <nio-icon class="text-lg" name="regular/remove" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: 'info',
                validator: (value) => ['info', 'success', 'warning', 'error'].includes(value),
            },
            message: {
                type: String,
                required: true,
            },
            link: {
                type: [String, Object],
                default: '',
            },
            icon: {
                type: String,
                default: '',
            },
            description: {
                type: String,
                default: '',
            },
            closable: {
                type: Boolean,
                default: true,
            },
        },

        computed: {
            iconName() {
                if (this.icon) {
                    return this.icon;
                }

                switch (this.type) {
                    case 'success':
                        return 'regular/check-circle-1';
                    case 'warning':
                        return 'regular/alert-triangle';
                    case 'error':
                        return 'regular/remove-circle';
                    case 'info':
                    default:
                        return 'regular/information-circle';
                }
            },

            iconClassName() {
                switch (this.type) {
                    case 'success':
                        return 'text-green-500';
                    case 'warning':
                        return 'text-yellow-500';
                    case 'error':
                        return 'text-red-500';
                    case 'info':
                    default:
                        return 'text-blue-500';
                }
            },
        },

        methods: {
            hide() {
                this.$emit('hide');
            },
        },
    };
</script>
